<div>
    <p-fieldset legend="Avsluta medlemskap i läger/förening">
      <form [formGroup]="terminatemembershipcampform">
        <div class="form-group">
          <label>Medlem</label>
          <div>{{memberid}} {{givenname}} {{familyname}}</div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="startCauseId">Avsluta medlemskap i</label>
            <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" required>
              <option></option>
              <option *ngFor="let c of camps" [ngValue]="c.institution.id">{{c.institution.shortName}} {{c.institution.name}}</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="fromDate">Ange datum</label>
            <app-calendar [form]="terminatemembershipcampform" formName="fromDate" [required]=true></app-calendar>
          </div>
        </div>
        <fieldset class="border p-2">
          <legend class="w-auto" style="font-size: 14px;">Orsak</legend>
          <br>
          <mat-radio-group formControlName="gott">
            <div>
              <mat-radio-button value=8>Medlem lämnat lägret/förening gottstående</mat-radio-button>
            </div>
            <div>
              <mat-radio-button value=11>Medlem lämnat lägret/förening ej gottstående</mat-radio-button>
            </div>
            <div>
              <mat-radio-button value=9>Medlem lämnat med avgångsbrev</mat-radio-button>
            </div>
          </mat-radio-group>
        </fieldset>
        <br>
      </form>

      <div class="d-flex justify-content-start">
        <button class="btn border" (click)="confirmDialog()" [disabled]="!terminatemembershipcampform.valid">Avsluta medlemskapet</button>
        <button class="btn border ms-2" (click)="close()">Avbryt</button>
      </div>

      <!--div class="col-md-12">
        <div class="row">
          <div>
            <button class="btn border" (click)="confirmDialog()" [disabled]="!terminatemembershipcampform.valid">Avsluta medlemskapet</button>
          </div>
          <div style="margin-left: 20px;">
            <button class="btn border" (click)="close()">Avbryt</button>
          </div>
        </div>
      </div-->
    </p-fieldset>
  </div>

